export function questionModel(
  questionId: int,
  questionName: string,
  isSelected: boolean
) {
  return { questionId, questionName, isSelected };
}
